import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: number;
  title: string;
  field_common_image: any;
  field_airport: string;
  images: any;
  field_created_date: string;
  field_updated_date: string;
  start_date: string;
  end_date: string;
  status: string;
}

// edit api call
const fetchHomePageCarouselDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/homepage-banners-view-list-data/all-fields/${id}`);
  return response.data[0];
};

const useHomePageCarouselDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["homePageCarouselDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchHomePageCarouselDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useHomePageCarouselDocumentDetails };
